module.exports = __webpack_public_path__ + "static/media/room3.73a948cf.jpg";